import { Button, LuIcon, Text } from "@overmap-ai/blocks"
import { type Issue, type IssueTypeIdentifier, OrganizationAccessLevel, type Stored } from "@overmap-ai/common"
import { memo, useCallback, useEffect, useState } from "react"

import { useUserOrganizationAccess } from "../../hooks/users"
import { modelIconMapping } from "../../mappings/icons"
import { sdk } from "../../sdk"
import { useAppSelector } from "../../store"
import { selectLatestIssueTypeIdentifierValueOfIssue } from "../../store/selectors/issues"
import { IdentifierEditorPopover } from "../Popovers/IdentifierEditorPopover"

interface IssueTypeIdentifiersListItemProps {
	issue: Stored<Issue>
	issueTypeIdentifier: Stored<IssueTypeIdentifier>
}

export const IssueTypeIdentifiersListItem = memo<IssueTypeIdentifiersListItemProps>((props) => {
	const { issue, issueTypeIdentifier } = props

	const isBasic = useUserOrganizationAccess(OrganizationAccessLevel.BASIC)
	const [value, setValue] = useState("")
	const issueTypeIdentifierValue = useAppSelector(
		selectLatestIssueTypeIdentifierValueOfIssue(issue.uuid, issueTypeIdentifier.uuid),
	)

	useEffect(() => {
		setValue(issueTypeIdentifierValue?.value ?? "")
	}, [issueTypeIdentifierValue?.value])

	const handleSave = useCallback(
		(value: string) => {
			void sdk.issueTypeIdentifierValues.add({
				value: value,
				issue: issue.uuid,
				issue_type_identifier: issueTypeIdentifier.uuid,
			})
		},
		[value, issue.uuid, issueTypeIdentifier.uuid],
	)

	return (
		<IdentifierEditorPopover initialValue={issueTypeIdentifierValue?.value ?? ""} onSave={handleSave} size="xs">
			<Button
				type="button"
				className="min-w-0 max-w-full shrink overflow-hidden"
				size="sm"
				accentColor="base"
				variant="soft"
				disabled={!isBasic}
			>
				<LuIcon icon={modelIconMapping.identifier} />
				<Text className="truncate">{issueTypeIdentifier.name}</Text>
				{issueTypeIdentifierValue?.value ? (
					<Text className="truncate" highContrast>
						{issueTypeIdentifierValue.value}
					</Text>
				) : (
					<Text className="text-(--base-a10)">No value</Text>
				)}
			</Button>
		</IdentifierEditorPopover>
	)
})
IssueTypeIdentifiersListItem.displayName = "IssueTypeIdentifiersListItem"
